import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import '../../asset/less/component.css'

import {message} from 'antd'

import {patchArtistContract} from '../../api/artistContracts'
import {is_admin_user} from "../../app/role";

@connect((state) => ({
    //decorator, gives component access to the state
    userId: state.user.info.id,
    email: state.user.info.email,
    role: state.user.info.role
}))
class Contract extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        function getFrameId(props) {
            let id = props.match.params.embed_url
            if (!id) {
                const locationArry = props.location.pathname.split('/')
                id = locationArry[locationArry.length - 3]
            }
            return id
        }

        // console.log( "https://revartllc.eversign.com/document/" + this.props.match.params.embed_url + "/sign")
        const frame_id = getFrameId(this.props)
        eversign.open({
            url: 'https://revartllc.eversign.com/document/' + frame_id + '/sign',
            containerID: 'container',
            width: 700,
            height: 900,
            events: {
                loaded: function () {
                },
                signed: () => {
                    const param = is_admin_user(this.props) ? {is_signed_revart: true} : {is_signed: true}
                    let request = patchArtistContract(this.props.match.params.id, param)
                    request
                        .then((response) => {
                            message.success('Signing saved')
                        })
                        .catch((error) => {
                            alert(JSON.stringify(error))
                            message.error(error.message)
                        })
                        .finally(() => {
                            this.props.history.push({pathname: '/'})
                            window.location.reload()
                        })
                },
                declined: function (d) {
                },
                error: function (e) {
                }
            }
        })
    }

    render() {
        return (
            <div>
                <div id='container'/>
            </div>
        )
    }
}

export default withRouter(Contract)
